
import { tsrClient } from '@/libs/ts-rest/ts-client';
import { CART_QUERY_KEYS } from '../../react-query';

const useGuestCartMutations = () => {
	const { guestCart } = tsrClient.web;
	const queryClient = tsrClient.useQueryClient();
	const invalidateGuestCartQuery = () => queryClient.invalidateQueries({ queryKey: CART_QUERY_KEYS.GUEST() });
	const removeGuestQuery = () => queryClient.removeQueries({ queryKey: CART_QUERY_KEYS.GUEST() });

	const getCart = async() => guestCart.get.query();
	const createCartMutation = guestCart.create.useMutation({ onSuccess: invalidateGuestCartQuery });
	const addCartItemMutation = guestCart.addCartItem.useMutation({ onSuccess: invalidateGuestCartQuery });
	const updateCartItemMutation = guestCart.updateCartItem.useMutation({ onSuccess: invalidateGuestCartQuery });
	const removeCartItemMutation = guestCart.removeCartItem.useMutation({ onSuccess: invalidateGuestCartQuery });
	const clearCartMutation = guestCart.clear.useMutation({ onSuccess: removeGuestQuery });

	return {
		getCart,
		createCartMutation,
		addCartItemMutation,
		updateCartItemMutation,
		removeCartItemMutation,
		clearCartMutation,
	};
};

export default useGuestCartMutations;
